var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-modal", {
    attrs: {
      id: "modal_edit_purchase_order",
      title: _vm.$t("Edição Parcial do Pedido"),
      "no-close-on-backdrop": "",
      "hide-header-close": "",
      size: "xl",
      scrollable: "",
      centered: "",
    },
    on: { hidden: _vm.hideModal },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function () {
          return [
            _c(
              "FormulateForm",
              {
                ref: "formPartialEditing",
                attrs: { name: "formPartialEditing" },
              },
              [
                _c(
                  "b-card-actions",
                  {
                    attrs: {
                      title:
                        _vm.$t("Pedido") +
                        " " +
                        _vm.form.purchaseOrderId +
                        " - " +
                        _vm.$t("Itens do Pedido"),
                      "show-loading": _vm.fetching,
                      "no-actions": "",
                    },
                  },
                  [
                    _c("b-table", {
                      staticClass: "bordered",
                      attrs: {
                        "show-empty": "",
                        striped: "",
                        fields: _vm.fields,
                        items: _vm.items,
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "cell(selection)",
                          fn: function (row) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-center align-items-center",
                                },
                                [
                                  _c("FormulateInput", {
                                    attrs: {
                                      id: "modal_item-edit_check_" + row.index,
                                      type: "e-checkbox",
                                      disabled: _vm.integratedWithBeerCooler(
                                        row.item
                                      ),
                                    },
                                    on: {
                                      change: function (val) {
                                        return _vm.onSelectToUpdate(
                                          val,
                                          row.item
                                        )
                                      },
                                    },
                                    model: {
                                      value: row.item.willUpdate,
                                      callback: function ($$v) {
                                        _vm.$set(row.item, "willUpdate", $$v)
                                      },
                                      expression: "row.item.willUpdate",
                                    },
                                  }),
                                  _vm.integratedWithBeerCooler(row.item)
                                    ? _c(
                                        "small",
                                        {
                                          staticClass:
                                            "text-muted mt-1 d-block text-center",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("Produto bloqueado.")
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: "cell(name)",
                          fn: function (ref) {
                            var item = ref.item
                            var index = ref.index
                            return [
                              !item.erpSku.sku || !item.erpSku.sku.name
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "margin-right": "5px",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticStyle: { width: "100%" } },
                                        [
                                          _c("FormulateInput", {
                                            staticClass: "ml-50",
                                            staticStyle: {
                                              width: "100%",
                                              "min-width": "200px",
                                              display: "inline-block",
                                            },
                                            attrs: {
                                              id:
                                                "order-items-sku-searched-" +
                                                index,
                                              type: "select-searchable",
                                              placeholder: _vm.$t(
                                                "Digite para pesquisar"
                                              ),
                                              options: _vm.skusOptions,
                                              autofocus: "",
                                              instruction: _vm.$t(
                                                "Digite pelo menos 3 numeros ou letras para iniciar a pesquisa"
                                              ),
                                              validation: item.willUpdate
                                                ? "required"
                                                : "",
                                              "validation-messages": {
                                                required: _vm.$t(
                                                  "Obrigatório informar o produto"
                                                ),
                                              },
                                            },
                                            on: {
                                              fetchSearch: _vm.fetchSearchSku,
                                              input: function ($event) {
                                                return _vm.selectSkuBuffered(
                                                  item,
                                                  $event
                                                )
                                              },
                                            },
                                            model: {
                                              value: item.erpSku._skuBuffer,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  item.erpSku,
                                                  "_skuBuffer",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "item.erpSku._skuBuffer",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  )
                                : _c(
                                    "div",
                                    { staticStyle: { display: "flex" } },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "center",
                                            margin: "3px 0",
                                          },
                                        },
                                        [
                                          _c("e-button", {
                                            staticClass: "p-5",
                                            attrs: {
                                              icon: "trash",
                                              variant: "danger",
                                              title:
                                                _vm.$t("Remover associação"),
                                              disabled: !item.willUpdate,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeSkuAssociation(
                                                  item.erpSku
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c("e-product-router-link", {
                                        attrs: {
                                          "sku-id": item.erpSku.sku.id,
                                          "product-id":
                                            item.erpSku.sku.productId,
                                          "product-name": item.erpSku.sku.name,
                                          ean: item.erpSku.sku.ean,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                            ]
                          },
                        },
                        {
                          key: "cell(quantity)",
                          fn: function (row) {
                            return [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "flex-direction": "column",
                                    "align-items": "center",
                                  },
                                },
                                [
                                  _c("FormulateInput", {
                                    staticClass: "text-right",
                                    staticStyle: { width: "80px" },
                                    attrs: {
                                      id: "order-items-quantity-" + row.index,
                                      type: "text-number",
                                      precision: 3,
                                      title: _vm.$t("Clique para editar"),
                                      validation: "required|min:0.001",
                                      "validation-messages": {
                                        required: _vm.$t("Obrigatório"),
                                        min: _vm.$t("Deve ser maior que zero"),
                                      },
                                      disabled: !row.item.willUpdate,
                                    },
                                    model: {
                                      value: row.item.erpSku.quantity,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          row.item.erpSku,
                                          "quantity",
                                          $$v
                                        )
                                      },
                                      expression: "row.item.erpSku.quantity",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "modal-footer",
        fn: function () {
          return [
            _c(
              "b-row",
              {
                staticClass:
                  "w-100 d-flex justify-content-between align-items-center",
              },
              [
                _c(
                  "b-col",
                  { staticClass: "d-flex justify-content-end" },
                  [
                    _c("e-button", {
                      staticClass: "mr-1",
                      attrs: {
                        id: "modal_return_invoice_items-btn_cancel",
                        variant: "outline-primary",
                        text: _vm.$t("Cancelar"),
                        "text-shortcuts": ["ESC"],
                      },
                      on: { click: _vm.hideModal },
                    }),
                    _c("e-button", {
                      attrs: {
                        id: "modal_return_invoice_items-btn_confirm",
                        variant: "primary",
                        text: _vm.$t("Confirmar"),
                        busy: _vm.busy,
                        disabled: !_vm.canConfirmEdits,
                      },
                      on: { click: _vm.onConfirm },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }